// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CropModal_modal__uzdg0 .modal__title {
  text-align: center;
  margin-bottom: 10px;
}
.CropModal_modal__uzdg0 .modal__inner {
  max-width: max-content;
}
.CropModal_modal__uzdg0 .modal__inner .modal__close-btn {
  top: 16px;
  right: 20px;
  z-index: 1;
}
.CropModal_modal__uzdg0 .modal__inner .modal__body {
  padding: 0;
}
@media (max-width: 640px) {
  .CropModal_modal__uzdg0 {
    padding: 20px;
  }
  .CropModal_modal__uzdg0 .modal__title {
    max-width: calc(100% - 40px);
    text-align: start;
  }
}

.CropModal_cropModalPopup__GxXAX {
  width: 600px;
  background: #fff;
  border-radius: 10px;
  padding: 20px;
  margin: auto;
  display: flex;
  flex-direction: column;
  position: relative;
}
.CropModal_cropModalPopup__wp__yiagf {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}
.CropModal_cropModalPopup__wp__yiagf .ReactCrop img {
  width: auto;
}
.CropModal_cropModalPopup__wp__yiagf .modal-close {
  position: absolute;
  top: 16px;
  right: 16px;
  cursor: pointer;
  width: 24px;
  height: 24px;
}
.CropModal_cropModalPopup__prev__fX0WH {
  margin-top: 12px;
}
.CropModal_cropModalPopup__prev-wp__OVWp- {
  display: flex;
  overflow: hidden;
  width: 150px;
  height: 150px;
}
.CropModal_cropModalPopup__prev-control__Ppeej {
  margin-left: 20px;
  display: flex;
}
.CropModal_cropModalPopup__prev-control__Ppeej button {
  height: 36px;
  padding-left: 10px;
  padding-right: 10px;
  margin-right: 10px;
}
.CropModal_cropModalPopup__button__Er95Y {
  width: 100%;
  display: flex;
}
.CropModal_cropModalPopup__button__Er95Y button {
  margin-top: 20px;
  height: 36px;
  padding: 12px 24px;
  width: 112px;
}
.CropModal_cropModalPopup__button__Er95Y button:last-child {
  margin-left: auto;
}
@media (max-width: 1200px) {
  .CropModal_cropModalPopup__button__Er95Y button {
    font-size: var(--fz-sm);
  }
}
.CropModal_cropModalPopup__button__Er95Y .CropModal_rotate-btn__Snb8M {
  background: #EEEEEE;
  color: initial;
}
@media (max-width: 640px) {
  .CropModal_cropModalPopup__GxXAX {
    width: auto;
  }
}

.CropModal_cropModal__photo__35zF4 {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.CropModal_cropModal__photo__input__jlyFB {
  position: absolute;
  top: 0;
  left: 0;
  width: 0;
  height: 0;
  background: transparent;
  opacity: 0;
}
.CropModal_cropModal__photo__container__lq8I1 {
  display: flex;
  width: 240px;
  height: 240px;
  border: 1px solid #E0E7EB;
  background: #EFF3F5;
  border-radius: 12px;
  overflow: hidden;
  position: relative;
}
.CropModal_cropModal__photo__container__lq8I1 svg {
  width: 100%;
  height: 100%;
}
@media (max-width: 640px) {
  .CropModal_cropModal__photo__container__lq8I1 svg {
    padding: 60px;
  }
}
.CropModal_cropModal__photo__container__lq8I1 img {
  width: 100%;
}
.CropModal_cropModal__photo__35zF4 .CropModal_no-filling__ZEAf\\+ {
  background: none;
  border: none;
}
.CropModal_cropModal__photo__35zF4 .CropModal_photo-img__L9h9X {
  max-width: 100%;
}
.CropModal_cropModal__photo__35zF4 svg {
  fill: none;
}
.CropModal_cropModal__photo__35zF4 .CropModal_loader__Ubc7d {
  width: 100%;
  height: 100%;
  z-index: 1;
  background: #EEEEEE;
  display: flex;
  align-items: center;
  justify-content: center;
}
.CropModal_cropModal__photo__35zF4 .CropModal_loader__Ubc7d svg {
  width: 120px;
  height: 120px;
}
.CropModal_cropModal__photo__35zF4 .CropModal_loader__Ubc7d svg circle {
  stroke: white;
}
@media (max-width: 640px) {
  .CropModal_cropModal__photo__35zF4 .CropModal_loader__Ubc7d svg {
    width: 100%;
    height: 100%;
  }
}
.CropModal_cropModal__photo__btn__AWKk2 {
  padding: 10px;
  width: 100%;
  background: #EEEEEE;
  font-size: 12px;
  line-height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  border-radius: 12px;
}
.CropModal_cropModal__photo__btn__AWKk2.CropModal_add-btn__zABtC svg {
  fill: #2DBE64;
}
.CropModal_cropModal__photo__btn__AWKk2.CropModal_remove-btn__YZqmg svg path {
  stroke: #F2200D;
}
.CropModal_cropModal__photo__btn__AWKk2:hover {
  opacity: 0.8;
}
@media (max-width: 640px) {
  .CropModal_cropModal__photo__btn__AWKk2 {
    position: absolute;
    width: 36px;
    height: 36px;
    background: rgba(0, 0, 0, 0.2392156863);
    top: 14px;
    right: 14px;
  }
  .CropModal_cropModal__photo__btn__AWKk2.CropModal_add-btn__zABtC svg {
    fill: white;
  }
  .CropModal_cropModal__photo__btn__AWKk2.CropModal_remove-btn__YZqmg svg path {
    stroke: white;
  }
}
.CropModal_cropModal__photo__35zF4 .CropModal_disabled-btn__\\+WwqJ {
  opacity: 0.5;
  cursor: default;
}`, "",{"version":3,"sources":["webpack://./src/components/CropModal/CropModal.module.scss"],"names":[],"mappings":"AAGI;EACE,kBAAA;EACA,mBAAA;AAFN;AAKI;EACE,sBAAA;AAHN;AAKM;EACE,SAAA;EACA,WAAA;EACA,UAAA;AAHR;AAMM;EACE,UAAA;AAJR;AASE;EAvBF;IAwBI,aAAA;EANF;EASI;IACE,4BAAA;IACA,iBAAA;EAPN;AACF;;AAYA;EACE,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;AATF;AAWE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;AATJ;AAcQ;EACE,WAAA;AAZV;AAgBM;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;AAdR;AAmBE;EACE,gBAAA;AAjBJ;AAmBI;EACE,aAAA;EACA,gBAAA;EACA,YAAA;EACA,aAAA;AAjBN;AAoBI;EACE,iBAAA;EACA,aAAA;AAlBN;AAoBM;EACE,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;AAlBR;AAuBE;EACE,WAAA;EACA,aAAA;AArBJ;AAuBI;EACE,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;AArBN;AAuBM;EACE,iBAAA;AArBR;AAwBM;EAVF;IAWI,uBAAA;EArBN;AACF;AAwBI;EACE,mBAAA;EACA,cAAA;AAtBN;AA0BE;EApFF;IAqFI,WAAA;EAvBF;AACF;;AA0BA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAvBF;AAyBE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,uBAAA;EACA,UAAA;AAvBJ;AA0BE;EACE,aAAA;EACA,YAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;AAxBJ;AA0BI;EACE,WAAA;EACA,YAAA;AAxBN;AA0BM;EAJF;IAKI,aAAA;EAvBN;AACF;AA0BI;EACE,WAAA;AAxBN;AA4BE;EACE,gBAAA;EACA,YAAA;AA1BJ;AA6BE;EACE,eAAA;AA3BJ;AA8BE;EACE,UAAA;AA5BJ;AA+BE;EACE,WAAA;EACA,YAAA;EACA,UAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AA7BJ;AA+BI;EACE,YAAA;EACA,aAAA;AA7BN;AA+BM;EACE,aAAA;AA7BR;AAgCM;EARF;IASI,WAAA;IACA,YAAA;EA7BN;AACF;AAiCE;EACE,aAAA;EACA,WAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,mBAAA;AA/BJ;AAkCM;EACE,aAAA;AAhCR;AAsCQ;EACE,eAAA;AApCV;AAyCI;EACE,YAAA;AAvCN;AA0CI;EA9BF;IA+BI,kBAAA;IACA,WAAA;IACA,YAAA;IACA,uCAAA;IACA,SAAA;IACA,WAAA;EAvCJ;EA0CM;IACE,WAAA;EAxCR;EA8CQ;IACE,aAAA;EA5CV;AACF;AAkDE;EACE,YAAA;EACA,eAAA;AAhDJ","sourcesContent":[".modal {\n  :global {\n\n    .modal__title {\n      text-align: center;\n      margin-bottom: 10px;\n    }\n\n    .modal__inner {\n      max-width: max-content;\n\n      .modal__close-btn {\n        top: 16px;\n        right: 20px;\n        z-index: 1;\n      }\n\n      .modal__body {\n        padding: 0;\n      }\n    }\n  }\n\n  @media (max-width: 640px) {\n    padding: 20px;\n\n    :global {\n      .modal__title {\n        max-width: calc(100% - 40px);\n        text-align: start;\n      }\n    }\n  }\n}\n\n.cropModalPopup {\n  width: 600px;\n  background: #fff;\n  border-radius: 10px;\n  padding: 20px;\n  margin: auto;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n\n  &__wp {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 100%;\n    height: 100%;\n\n    :global {\n      .ReactCrop {\n\n        img {\n          width: auto;\n        }\n      }\n\n      .modal-close {\n        position: absolute;\n        top: 16px;\n        right: 16px;\n        cursor: pointer;\n        width: 24px;\n        height: 24px;\n      }\n    }\n  }\n\n  &__prev {\n    margin-top: 12px;\n\n    &-wp {\n      display: flex;\n      overflow: hidden;\n      width: 150px;\n      height: 150px;\n    }\n\n    &-control {\n      margin-left: 20px;\n      display: flex;\n\n      button {\n        height: 36px;\n        padding-left: 10px;\n        padding-right: 10px;\n        margin-right: 10px;\n      }\n    }\n  }\n\n  &__button {\n    width: 100%;\n    display: flex;\n\n    button {\n      margin-top: 20px;\n      height: 36px;\n      padding: 12px 24px;\n      width: 112px;\n\n      &:last-child {\n        margin-left: auto;\n      }\n\n      @media (max-width: 1200px) {\n        font-size: var(--fz-sm);\n      }\n    }\n\n    .rotate-btn {\n      background: #EEEEEE;\n      color: initial;\n    }\n  }\n\n  @media (max-width: 640px) {\n    width: auto;\n  }\n}\n\n.cropModal__photo {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n\n  &__input {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 0;\n    height: 0;\n    background: transparent;\n    opacity: 0;\n  }\n\n  &__container {\n    display: flex;\n    width: 240px;\n    height: 240px;\n    border: 1px solid #E0E7EB;\n    background: #EFF3F5;\n    border-radius: 12px;\n    overflow: hidden;\n    position: relative;\n\n    svg {\n      width: 100%;\n      height: 100%;\n\n      @media (max-width: 640px) {\n        padding: 60px;\n      }\n    }\n\n    img {\n      width: 100%;\n    }\n  }\n\n  .no-filling {\n    background: none;\n    border: none;\n  }\n\n  .photo-img {\n    max-width: 100%;\n  }\n\n  svg {\n    fill: none;\n  }\n\n  .loader {\n    width: 100%;\n    height: 100%;\n    z-index: 1;\n    background: #EEEEEE;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    svg {\n      width: 120px;\n      height: 120px;\n\n      circle {\n        stroke: white;\n      }\n\n      @media (max-width: 640px) {\n        width: 100%;\n        height: 100%;\n      }\n    }\n  }\n\n  &__btn {\n    padding: 10px;\n    width: 100%;\n    background: #EEEEEE;\n    font-size: 12px;\n    line-height: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 5px;\n    border-radius: 12px;\n\n    &.add-btn {\n      svg {\n        fill: #2DBE64;\n      }\n    }\n\n    &.remove-btn {\n      svg {\n        path {\n          stroke: #F2200D;\n        }\n      }\n    }\n\n    &:hover {\n      opacity: 0.8;\n    }\n\n    @media (max-width: 640px) {\n      position: absolute;\n      width: 36px;\n      height: 36px;\n      background: #0000003D;\n      top: 14px;\n      right: 14px;\n\n      &.add-btn {\n        svg {\n          fill: white;\n        }\n      }\n\n      &.remove-btn {\n        svg {\n          path {\n            stroke: white;\n          }\n        }\n      }\n    }\n  }\n\n  .disabled-btn {\n    opacity: 0.5;\n    cursor: default;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": `CropModal_modal__uzdg0`,
	"cropModalPopup": `CropModal_cropModalPopup__GxXAX`,
	"cropModalPopup__wp": `CropModal_cropModalPopup__wp__yiagf`,
	"cropModalPopup__prev": `CropModal_cropModalPopup__prev__fX0WH`,
	"cropModalPopup__prev-wp": `CropModal_cropModalPopup__prev-wp__OVWp-`,
	"cropModalPopup__prev-control": `CropModal_cropModalPopup__prev-control__Ppeej`,
	"cropModalPopup__button": `CropModal_cropModalPopup__button__Er95Y`,
	"rotate-btn": `CropModal_rotate-btn__Snb8M`,
	"cropModal__photo": `CropModal_cropModal__photo__35zF4`,
	"cropModal__photo__input": `CropModal_cropModal__photo__input__jlyFB`,
	"cropModal__photo__container": `CropModal_cropModal__photo__container__lq8I1`,
	"no-filling": `CropModal_no-filling__ZEAf+`,
	"photo-img": `CropModal_photo-img__L9h9X`,
	"loader": `CropModal_loader__Ubc7d`,
	"cropModal__photo__btn": `CropModal_cropModal__photo__btn__AWKk2`,
	"add-btn": `CropModal_add-btn__zABtC`,
	"remove-btn": `CropModal_remove-btn__YZqmg`,
	"disabled-btn": `CropModal_disabled-btn__+WwqJ`
};
export default ___CSS_LOADER_EXPORT___;
